import { createFileRoute } from "@tanstack/react-router";

import { PlatformHead, PlatformPage } from "@/features/platform/components/platform-chrome";
import { PlatformClosing } from "@/features/platform/modules/closing/platform-closing";
import { PlatformQuestions } from "@/features/platform/modules/questions/platform-questions";
import { StartHero, StartSteps } from "@/features/platform/modules/start-page/start-page";
import { TeamSize } from "@/features/platform/modules/team/team-size";
import { pageMeta } from "@/lib/seo";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(public)/how-it-works/")({
  head: () => ({ meta: pageMeta({ title: m.seo_how_title(), description: m.seo_how_description() }) }),
  loader: () => ({ crumb: m.platform_nav_how() }),
  component: HowItWorksPage,
});

/**
 * Moving a business here, stop by stop: the account and page, the hours, the link, the first
 * booking; then a team of any size and the questions trainers ask before they move.
 */
function HowItWorksPage() {
  return (
    <PlatformPage
      head={
        <PlatformHead>
          <StartHero />
        </PlatformHead>
      }
    >
      <StartSteps />
      <TeamSize />
      <PlatformQuestions />
      <PlatformClosing />
    </PlatformPage>
  );
}
